import { createSnackbarQueue } from "@kaggle/material";

export const editorQueue = createSnackbarQueue();
